<template>
    <div id="ContainerRole" class="page-height">
        <div class="row">
            <div class="col-12">
                <h4 class="page-title text-truncate"> {{$tc('userRoleDetails.rSetup',2)}}</h4>
                <b-row class="mt-3">
                    <b-col md="3" lg="3" sm="12">
                        <MdEdit 
                                v-bind:Label="$t('Shared.Name')"
                                v-bind:TypeProp="'text'" 
                                v-bind:Name="'description'"
                                v-bind:isRequired="true"
                                v-bind:Id="'input_role_name'"
                                v-bind:isValid="isRoleIdValid"
                                v-model="Rol.description"
                                v-bind:MaxLengthProp="100"
                                >                                     
                        </MdEdit>
                    </b-col>
                </b-row>
                <b-row class="mt-3">
                    <b-col md="12" lg="12" sm="12">
                        <div class="accordion" role="tablist">
                            <b-card no-body class="mb-1">
                                <b-card-header
                                    header-tag="header"
                                    class="p-1"
                                    role="tab">
                                    <b-button
                                        block							
                                        class="collapseBTN"
                                        v-on:click="ClickBtnAccordion($event, 'Menu')"
                                        :disabled="isDisabled"
                                        v-b-toggle.role-accordion-1
                                        ><b-icon
                                            icon="arrow-down-right-circle"
                                            aria-hidden="true"
                                        ></b-icon>
                                        {{ $t('userRoleDetails.Menu') }}</b-button>
                                </b-card-header>

                                <b-collapse 
                                    id="role-accordion-1" 
                                    accordion="role-accordion" 
                                    role="tabpanel"
                                    v-show="IsAccordionVisible('Menu')"
                                    :class="GetClassAccordion('Menu')"
                                >
                                    <b-card-body>
                                        <DxTreeList
                                            id="treeMenu"
                                            :ref="treeListRefKey"
                                            :data-source="this.dataSource"
                                            :show-borders="true"
                                            :column-auto-width="true"
                                            :word-wrap-enabled="true"
                                            key-expr="itemKey"
                                            parent-id-expr="parentId"
                                            @saving="SaveOrEditPerm($event)"
                                            @editor-preparing="onEditorPreparingPerm"
                                            @cell-prepared="cellPrepared"
                                            :height="'60vh'">

                                            <DxSearchPanel :visible="true" :width="250" :placeholder="$t('Shared.Search')"/>
                                            <DxSorting mode="none"/> <!-- or "multiple" | "none" -->
                                            <DxToolbar>
                                                <DxItem name="searchPanel" :width="250" />
                                            </DxToolbar>
                                            <DxEditing :allow-updating="true" mode="batch"/>
                                                        
                                            <DxColumn
                                                :width="300"
                                                data-field="itemName"
                                                :caption="$t('userRoleDetails.accTo')"
                                                :allow-editing="false"
                                            />

                                            <DxColumn
                                                data-field="roleAllowAll"
                                                :set-cell-value="setCellValue"
                                                headerCellTemplate ="headerCellTemplateAll"
                                            
                                            />
                                            <template #headerCellTemplateAll="{ data }">
                                                <DxCheckBox 
                                                    :value="false"
                                                    :text="$t('userRoleDetails.aAll')"
                                                    iconSize="16px"
                                                    @value-changed="onValueChangedCheck($event, data)"/>
                                            </template>

                                            <DxColumn
                                                data-field="roleCanView"
                                                headerCellTemplate ="headerCellTemplate"
                                            />
                                            <template #headerCellTemplate="{ data }">
                                                <DxCheckBox 
                                                    :value="false"
                                                    :text="$t('Shared.View')"
                                                    iconSize="16px"
                                                    @value-changed="onValueChangedCheck($event, data)"/>
                                            </template>

                                            <DxColumn
                                                data-field="roleCanAdd"
                                                data-type="boolean"
                                                headerCellTemplate ="headerCellTemplateAdd"
                                            />
                                            <template #headerCellTemplateAdd="{ data }">
                                                <DxCheckBox 
                                                    :value="false"
                                                    :text="$t('Shared.Add')"
                                                    iconSize="16px"
                                                    @value-changed="onValueChangedCheck($event, data)"/>
                                            </template>

                                            <DxColumn
                                                data-field="roleCanEdit"
                                                data-type="boolean"
                                                headerCellTemplate ="headerCellTemplateEdit"
                                            />
                                            <template #headerCellTemplateEdit="{ data }">
                                                <DxCheckBox 
                                                    :value="false"
                                                    :text="$t('Shared.Edit')"
                                                    iconSize="16px"
                                                    @value-changed="onValueChangedCheck($event, data)"/>
                                            </template>

                                            <DxColumn
                                                data-field="roleCanDelete"
                                                data-type="boolean"
                                                headerCellTemplate ="headerCellTemplateDel"
                                            />
                                            <template #headerCellTemplateDel="{ data }">
                                                <DxCheckBox 
                                                    :value="false"
                                                    :text="$t('Shared.Delete')"
                                                    iconSize="16px"
                                                    @value-changed="onValueChangedCheck($event, data)"/>
                                            </template>

                                            <DxColumn :visible="false" data-field="hasAdd" data-type="boolean"/>
                                            <DxColumn :visible="false" data-field="hasDelete" data-type="boolean"/>
                                            <DxColumn :visible="false" data-field="hasEdit" data-type="boolean"/>
                                        </DxTreeList>
                                        <b-row>
                                            <b-col md="12" sm="12" class="my-3">
                                                <div>
                                                    <MdButton
                                                        v-bind:Label="$t('Shared.BtnSave')"
                                                        v-bind:Name="'btnSaveRole'"
                                                        v-bind:ClassProp="'secondary mx-2 btn-login pull-right'"
                                                        v-on:click="treeList.saveEditData()"/>   
                                                </div>
                                                <div>
                                                    <MdButton
                                                        v-bind:Label="$t('Shared.BtnCancel')"
                                                        v-bind:Name="'btnCancelRole'"
                                                        v-bind:ClassProp="'secondary mx-2 btn-login pull-right'"
                                                        v-on:click="treeList.cancelEditData()"/>   
                                                </div>
                                            </b-col>
                                        </b-row>
                                    </b-card-body>
                                </b-collapse>
                            </b-card>

                            <b-card no-body class="mb-1">
                                <b-card-header
                                    header-tag="header"
                                    class="p-1"
                                    role="tab">
                                    <b-button
                                        block							
                                        class="collapseBTN"
                                        v-on:click="ClickBtnAccordion($event, 'Provider')"
                                        v-b-toggle.role-accordion-2
                                        ><b-icon
                                            icon="arrow-down-right-circle"
                                            aria-hidden="true"
                                        ></b-icon>
                                        {{ $t('modalProviderSelector.Provider') }}</b-button>
                                </b-card-header>

                                <b-collapse 
                                    id="role-accordion-2" 
                                    accordion="role-accordion" 
                                    role="tabpanel"
                                    v-show="IsAccordionVisible('Provider')"
                                >
                                    <b-card-body>
                                        <DxTreeList
                                            :ref="treeListProRefKey"
                                            :data-source="this.provDataSource"
                                            :show-borders="true"
                                            :column-auto-width="true"
                                            :word-wrap-enabled="true"
                                            key-expr="itemId"
                                            @saving="SaveOrEdit($event)"
                                            class="column-view-check"
                                            :height="'50vh'"
                                        >
                                            <DxEditing :allow-updating="true" mode="batch"/>
                                            <DxSearchPanel :visible="true" :width="250" :placeholder="$t('Shared.Search')"/>
                                            <DxSorting mode="none"/> <!-- or "multiple" | "none" -->
                                            <DxToolbar>
                                                <DxItem name="searchPanel" :width="250" />
                                            </DxToolbar>
                    
                                            <DxColumn
                                                width="30px"
                                                data-field="roleCanView"
                                                data-type="boolean"
                                                headerCellTemplate ="headerCellTemplateAllP"
                                                css-class="headercell-view-padding"
                                            />
                                            <template #headerCellTemplateAllP="{ data }">
                                                <DxCheckBox 
                                                    :value="false"
                                                    text=""
                                                    iconSize="16px"
                                                    @value-changed="onValueChangedCheckP($event, data)"/>
                                            </template>
                                            <DxColumn
                                                data-field="itemName"
                                                :caption="$t('modalProviderSelector.Provider')"
                                                :read-only="true"
                                                :allow-editing="false"
                                                css-class="cell-provider-align"
                                            />
                                        </DxTreeList>
                                            
                                        <b-row>
                                            <b-col md="12" sm="12" class="my-3">
                                                <div>
                                                    <MdButton
                                                        v-bind:Label="$t('Shared.Save')"
                                                        v-bind:Name="'btnSaveProvider'"
                                                        v-bind:ClassProp="'secondary mx-2 btn-login pull-right'"
                                                        v-on:click="treeListPro.saveEditData()"/>   
                                                </div>
                                                <div>
                                                    <MdButton
                                                        v-bind:Label="$t('Shared.BtnCancel')"
                                                        v-bind:Name="'btnCancelProv'"
                                                        v-bind:ClassProp="'secondary mx-2 btn-login pull-right'"
                                                        v-on:click="treeListPro.cancelEditData()"/>   
                                                </div>
                                            </b-col>
                                        </b-row>
                                    </b-card-body>
                                </b-collapse>
                            </b-card>

                            <b-card no-body class="mb-1">
                                <b-card-header
                                    header-tag="header"
                                    class="p-1"
                                    role="tab">
                                    <b-button
                                        block							
                                        class="collapseBTN"
                                        v-on:click="ClickBtnAccordion($event, 'CNAssignment')"
                                        v-b-toggle.role-accordion-3
                                        :disabled="isDisabled"
                                        ><b-icon
                                            icon="arrow-down-right-circle"
                                            aria-hidden="true"
                                        ></b-icon>
                                        {{ $t('userRoleDetails.CNAssignment') }}</b-button>
                                </b-card-header>

                                <b-collapse 
                                    id="role-accordion-3" 
                                    accordion="role-accordion" 
                                    role="tabpanel"
                                    v-show="IsAccordionVisible('CNAssignment')"
                                    :class="GetClassAccordion('CNAssignment')"
                                >
                                    <b-card-body>
                                        <ClinicalTab
                                            v-bind:RolId="this.RolId"
                                            v-bind:AccordionVisible="IsAccordionVisible('CNAssignment')"
                                        ></ClinicalTab>
                                    </b-card-body>
                                </b-collapse>
                            </b-card>

                            <b-card no-body class="mb-1">
                                <b-card-header
                                    header-tag="header"
                                    class="p-1"
                                    role="tab">
                                    <b-button
                                        block							
                                        class="collapseBTN"
                                        v-on:click="ClickBtnAccordion($event, 'EHRFeatures')"
                                        v-b-toggle.role-accordion-4
                                        :disabled="isDisabled"
                                        ><b-icon
                                            icon="arrow-down-right-circle"
                                            aria-hidden="true"
                                        ></b-icon>
                                        {{ $t('userRoleDetails.EHRFeatures') }}</b-button>
                                </b-card-header>

                                <b-collapse 
                                    id="role-accordion-4" 
                                    accordion="role-accordion" 
                                    role="tabpanel"
                                    v-show="IsAccordionVisible('EHRFeatures')"
                                    :class="GetClassAccordion('EHRFeatures')"
                                >
                                    <b-card-body>
                                        <EHRFeaturesTab
                                            v-bind:RolId="this.RolId"
                                            v-bind:AccordionVisible="IsAccordionVisible('EHRFeatures')"
                                        ></EHRFeaturesTab>
                                    </b-card-body>
                                </b-collapse>
                            </b-card>

                            <b-card no-body class="mb-1">
                                <b-card-header
                                    header-tag="header"
                                    class="p-1"
                                    role="tab">
                                    <b-button
                                        block							
                                        class="collapseBTN"
                                        v-on:click="ClickBtnAccordion($event, 'CustomExport')"
                                        v-b-toggle.role-accordion-5
                                        :disabled="isDisabled"
                                        ><b-icon
                                            icon="arrow-down-right-circle"
                                            aria-hidden="true"
                                        ></b-icon>
                                        {{ $t('userRoleDetails.CustomExport') }}</b-button>
                                </b-card-header>

                                <b-collapse 
                                    id="role-accordion-5" 
                                    accordion="role-accordion" 
                                    role="tabpanel"
                                    v-show="IsAccordionVisible('CustomExport')"
                                    :class="GetClassAccordion('CustomExport')"
                                >
                                    <b-card-body>
                                        <CustomExportTab
                                            v-bind:RolId="this.RolId"
                                            v-bind:AccordionVisible="IsAccordionVisible('CustomExport')"
                                        ></CustomExportTab>
                                    </b-card-body>
                                </b-collapse>
                            </b-card>

                            <b-card no-body class="mb-1">
                                <b-card-header
                                    header-tag="header"
                                    class="p-1"
                                    role="tab">
                                    <b-button
                                        block							
                                        class="collapseBTN"
                                        v-on:click="ClickBtnAccordion($event, 'ExcludeCosigner')"
                                        v-b-toggle.role-accordion-6
                                        :disabled="isDisabled"
                                        ><b-icon
                                            icon="arrow-down-right-circle"
                                            aria-hidden="true"
                                        ></b-icon>
                                        {{ $t('userRoleDetails.ExcludeCosigner') }}</b-button>
                                </b-card-header>

                                <b-collapse 
                                    id="role-accordion-6" 
                                    accordion="role-accordion" 
                                    role="tabpanel"
                                    v-show="IsAccordionVisible('ExcludeCosigner')"
                                    :class="GetClassAccordion('ExcludeCosigner')"
                                >
                                    <b-card-body>
                                        <ExcludeCosignerTab
                                            v-bind:RolId="this.RolId"
                                            v-bind:AccordionVisible="IsAccordionVisible('ExcludeCosigner')"
                                        ></ExcludeCosignerTab>
                                    </b-card-body>
                                </b-collapse>
                            </b-card>

                            <b-card no-body class="mb-1">
                                <b-card-header
                                    header-tag="header"
                                    class="p-1"
                                    role="tab">
                                    <b-button
                                        block							
                                        class="collapseBTN"
                                        v-on:click="ClickBtnAccordion($event, 'CosignerNeeding')"
                                        v-b-toggle.role-accordion-7
                                        :disabled="isDisabled"
                                        ><b-icon
                                            icon="arrow-down-right-circle"
                                            aria-hidden="true"
                                        ></b-icon>
                                        {{ $t('userRoleDetails.CosignerNeeding') }}</b-button>
                                </b-card-header>

                                <b-collapse 
                                    id="role-accordion-7" 
                                    accordion="role-accordion" 
                                    role="tabpanel"
                                    v-show="IsAccordionVisible('CosignerNeeding')"
                                    :class="GetClassAccordion('CosignerNeeding')"
                                >
                                    <b-card-body>
                                        <NeedingCosignerTab
                                            v-bind:RolId="this.RolId"
                                            v-bind:AccordionVisible="IsAccordionVisible('CosignerNeeding')"
                                        ></NeedingCosignerTab>
                                    </b-card-body>
                                </b-collapse>
                            </b-card>

                        </div>
                    </b-col>
                </b-row>
            </div>
        </div>
        
        <div class="space-actions"></div>
        <div class="page-actions">
            <MdButton
                v-bind:Label="$tc('Shared.Back')"
                v-bind:Name="'btnrollist'"
                v-bind:ClassProp="'secondary mx-2 btn-login'"
                v-on:click="DiscardChanges"/>           
        </div>
    </div>
</template>

<script>
import UserTplService from '@/services/users.tpl.service'
import ShowMessage from '@/components/messages/ShowMessage.js'
import DBFunctions from '@/common/DBFunctions.js'
import { EventBus } from '@/event-bus.js';
import {
    DxTreeList,
    DxColumn,
    DxEditing,
    DxToolbar,
    DxItem,
    DxSearchPanel,
    DxSorting   
} from 'devextreme-vue/tree-list';
import { DxCheckBox } from 'devextreme-vue/check-box';
import Permission from '@/common/Permission'
import ClinicalTab from '@/components/pages/setup/users/userTemplate/tabs/userRoleDetailCNA'
import ExcludeCosignerTab from '@/components/pages/setup/users/userTemplate/tabs/userRoleDetailEC'
import NeedingCosignerTab from '@/components/pages/setup/users/userTemplate/tabs/userRoleDetailNC'
import CustomExportTab from '@/components/pages/setup/users/userTemplate/tabs/userRoleDetailCE'
import EHRFeaturesTab from '@/components/pages/setup/users/userTemplate/tabs/userRoleDetailEHR'

const treeListRefKey = 'myTreeList';
const treeListProRefKey = 'myTreeListProv';

/* eslint-disable vue/no-unused-components */
export default {
    beforeRouteLeave(to, from, next) {
        if (!this.isReadOnly && this.pendingChanges) {
            this.$bvModal
                .msgBoxConfirm(this.$t('Msg.LeavingWithoutSaving'), {
                    title: this.$t('userHeader.uSetup'),
                    okTitle: this.$t('Shared.Save'),
                    cancelTitle: this.$t('Shared.BtnDismiss'),
                    footerClass: 'p-2',
                    titleClass: 'modal-title modal-type-warning'
                })
                .then(value => {
                    if(!value){
                        this.checkExistFavorite('/app/roles');
                        next();
                    } else {
                        this.SaveOrEdit();
                        next();
                    }
                })		
        } else {
            next()
        }
    },

    mixins: [ShowMessage,DBFunctions,Permission],
    components: {
        DxTreeList,
        DxColumn,
        DxSearchPanel,
        DxEditing,
        DxToolbar,
        DxItem,
        DxCheckBox,
        DxSorting,
        ClinicalTab,
        ExcludeCosignerTab,
        NeedingCosignerTab,
        CustomExportTab,
        EHRFeaturesTab
    },

    data() {
        return {
            showProviderType: false, 
            dataSource:[],
            provDataSource:[],
            OptionsRightMenu:{
                visible:false,
                btnvisible:false,
                ItemsList:[],
                favButtonAtion: false        
            },
            checkBoxValue: false,
            Mode:this.$attrs.editMode, 
            Clone:this.$attrs.clone,
            treeListRefKey,
            treeListProRefKey,
            
            dataRolProvider: {
                providers:[]
            },
            dataRolPermision: {
                userRoleMenuItems:[],
                roleTemplateCode: ''
            },
            RolId:'',
            Rol:{
                description:"",
            },
            isRoleIdValid:true,
            pendingChanges: false,
            disabled: true,
            triggerOnChange: false, 
            currentAccordion: 'Provider'
        };
    },

    methods: {
        ClickBtnAccordion(event, value) {
            if (this.currentAccordion == 'Menu' && value != 'Menu') {
                let changes = this.treeList.option("editing.changes");
                if (changes.length != 0) {
                    this.showMessage(this.$tc('Msg.Warning'),this.$t('userRoleDetails.LeavingWithoutSaving', {name: this.$t('userRoleDetails.Menu').toUpperCase()}),"warning");
                }
            } else if (this.currentAccordion == 'Provider' && value != 'Provider') {
                let changes = this.treeListPro.option("editing.changes");
                if (changes.length != 0) {
                    this.showMessage(this.$tc('Msg.Warning'),this.$t('userRoleDetails.LeavingWithoutSaving', {name: this.$t('modalProviderSelector.Provider').toUpperCase()}),"warning");
                }
            }

            this.currentAccordion = value;
            if (value == 'Menu') {
                this.getDataSource(event);
            }
        },

        IsAccordionVisible(value) {
            return this.currentAccordion == value;
        },

        GetClassAccordion(value) {
            return value == this.currentAccordion ? 'show' : '';
        },

        getProviders() {
            UserTplService.getProviders(this.RolId)
                .then((response) => { 
                    if(response.data){
                        this.provDataSource = response.data
                        if (this.Mode) {
                            this.Rol.description = response.data.description;
                            this.provDataSource = response.data.providers;
                            this.RolId = response.data.code
                            this.disabled = false
                        } else if (this.Clone) {
                            this.provDataSource = response.data.providers;
                        }
                    }       
                })
                .catch((error) => {
                    this.showResponseErrorMessage(error);
                });
        },

        DiscardChanges(){
            if(!this.pendingChanges)
                this.checkExistFavorite('/app/roles');
            this.$router.push({name: "roles"});
        },

        PrepareRolePovider(e){
            this.dataRolProvider.description = this.Rol.description;
            this.dataRolProvider.providers = e.component.getDataSource().store()._array;
        },

        SaveOrEdit(e){
            if(!this.isReadOnly) {
                if (this.validate_required()) {     
                    this.PrepareRolePovider(e);      
                    if (this.Mode) { 
                        this.UpdateRolProvider();
                    }else{  
                        if (this.Clone) {
                            this.CloneRolProvider();
                        } else {
                            this.AddRolProvider();
                        }
                    }
                } else {
                    this.showMessage(this.$tc('Msg.Error'), this.$t('Msg.CheckRedLabeledFields'), "errorAutoHide");           
                }
            } 
        },

    
        CloneRolProvider(){
            UserTplService.clone(this.$route.params.id, this.dataRolProvider)
                .then((response) => { 
                    if (response.status == '200') {   
                        this.pendingChanges = false; 
                        this.disabled = false;  
                        this.RolId = response.data.code;
                        this.Clone = false;
                        setTimeout(() => 
                            this.$bvToast.toast(this.$t('Msg.SavedSuccessfully'), {
                                title: this.$t('Msg.Success'),
                                autoHideDelay: 5000,
                                variant: "success"
                            }
                        ), 50);
                    }
                    this.dataRolProvider.providers = []; 
                    this.dataRolProvider.description = ''; 

                    this.Mode = true;
                })
                .catch(error => { 
                    this.dataRolProvider.providers = []; 
                    this.dataRolProvider.description = ''; 

                    this.showResponseErrorMessage(error);
                },this);   
        },

        AddRolProvider(){
            UserTplService.add(this.dataRolProvider)
                .then((response) => { 
                    if (response.status == '200') {   
                        this.pendingChanges = false; 
                        this.disabled = false;  
                        this.RolId = response.data.code
                        setTimeout(() => 
                            this.$bvToast.toast(this.$t('Msg.SavedSuccessfully'), {
                                title: this.$t('Msg.Success'),
                                autoHideDelay: 5000,
                                variant: "success"
                            }
                        ), 50);
                    }
                    this.dataRolProvider.providers = []; 
                    this.dataRolProvider.description = ''; 

                    this.Mode = true;
                })
                .catch(error => { 
                    this.dataRolProvider.providers = []; 
                    this.dataRolProvider.description = ''; 

                    this.showResponseErrorMessage(error);
                }, this);   
        },

        UpdateRolProvider(){
            UserTplService.update(this.RolId, this.dataRolProvider)
                .then((response) => {      
                    if (response.status == '200') {   
                        this.pendingChanges = false; 
                            setTimeout(() => 
                                this.$bvToast.toast(this.$t('Msg.SavedSuccessfully'), {
                                title: this.$t('Msg.Success'),
                                autoHideDelay: 5000,
                                variant: "success"
                                }
                            ), 50); 
                    }
                    this.dataRolProvider.providers = []; 
                    this.dataRolProvider.description = ''; 
                })
                .catch(error => {
                    this.dataRolProvider.providers = []; 
                    this.dataRolProvider.description = '';  

                    this.showResponseErrorMessage(error);
                },this);
        },

        onValueChangedCheckP(e, d) {
            let changes = this.treeListPro.option("editing.changes");
            let dataField =  d.column.dataField

            this.treeListPro.forEachNode((node) => {
                let curNode = changes.find((el) => {
                    return node.key === el.key;
                });

                if (curNode) {
                    curNode.data[dataField] = e.value;
                } else {
                    changes.push({
                        key: node.key,
                        data: { [dataField] : e.value },
                        type: "update",
                    });
                }
            });
            this.treeListPro.option("editing.changes", changes);
        },

        // --------------Code for permmission treelist ----------------------
        getDataSource(e) {
            if (e.srcElement.ariaExpanded == 'false'){
                UserTplService.getProvidersTypes()
                    .then((response) => { 
                        if(response.data && response.data.length > 0){
                            var paramType = this.dataRolPermision.moduleCode ? this.triggerOnChange == true : 'ALL';
                            
                            UserTplService.getDataSource(paramType,this.RolId)
                                .then((response) => { 
                                    if(response.data && response.data.length > 0){
                                        this.dataSource = response.data
                                    }       
                                })
                                .catch((error) => {
                                    this.showResponseErrorMessage(error);
                                });
                        }
                    })
                    .catch((error) => {
                        this.showResponseErrorMessage(error);
                    });
            }
        },

        onChangeDataSource(e) {
            if (e) {
                UserTplService.getDataSource(e.types, this.RolId)
                    .then((response) => { 
                        if(response.data && response.data.length > 0){
                            this.dataSource = response.data;
                        }
                        this.dataRolPermision.moduleCode = e.types;
                        this.triggerOnChange = true;        
                    })
                    .catch((error) => {
                        this.showResponseErrorMessage(error);
                    });
            }      
        },
    
        PrepareRolPermision(e){
            if(!this.triggerOnChange) 
                this.dataRolPermision.moduleCode = 'ALL';

            this.dataRolPermision.roleTemplateCode = this.RolId;
            this.dataRolPermision.deviceCode = "WEB"

            this.dataRolPermision.userRoleMenuItems = e.component.getDataSource().store()._array;
        },

        SaveOrEditPerm(e){
            if(!this.isReadOnly) {
                this.PrepareRolPermision(e);
                setTimeout(() => {
                    if (this.validate_menu_required()) {     
                        this.AddRolPermision();
                    }
                }, 50);
            } else {
                this.showMessage(this.$tc('Msg.Error'), this.$t('Shared.ReadOnlyPermission'), "errorAutoHide");           
            }
        },

        AddRolPermision(){
            UserTplService.addPermision(this.dataRolPermision)
                .then((response) => { 
                    if (response.status == '200') {   
                        this.pendingChanges = false; 
                        setTimeout(() => 
                            this.$bvToast.toast(this.$t('Msg.SavedSuccessfully'), {
                                title: this.$t('Msg.Success'),
                                autoHideDelay: 5000,
                                variant: "success"
                            }), 50); 
                    }
                })
                .catch(error => { 
                    this.showResponseErrorMessage(error);
                }, this);   
        },

        onEditorPreparingPerm(e) {
            if (e.parentType ==="dataRow") {
                if(e.dataField === "roleCanEdit" ){
                    e.editorOptions.disabled = e.row.data && e.row.data.hasEdit === false;
                }
                else if(e.dataField === "roleCanAdd"){
                    e.editorOptions.disabled = e.row.data && e.row.data.hasAdd === false;
                }
                else if (e.dataField === "roleCanDelete"){
                    e.editorOptions.disabled = e.row.data && e.row.data.hasDelete === false;
                } 
                else if (e.dataField === "roleAllowAll" && e.row.data){
                    e.editorOptions.disabled = true;
                    if (e.row.data.hasDelete === true || e.row.data.hasAdd === true || e.row.data.hasEdit === true)
                        e.editorOptions.disabled = false;
                }
            }

            e.editorOptions.onValueChanged = (ev) => this.onValueChanged(e, ev);
        },

        onValueChanged(e, ev) {
            if (e.dataField === "roleAllowAll") {
                this.checkRoleAllowAllChanges(e.row.data, ev.value);

                if (e.row.data.hasAdd)
                    e.component.cellValue(e.row.rowIndex, "roleCanAdd", ev.value);
                if (e.row.data.hasEdit)
                    e.component.cellValue(e.row.rowIndex, "roleCanEdit", ev.value);
                if (e.row.data.hasDelete)
                    e.component.cellValue(e.row.rowIndex, "roleCanDelete", ev.value);
                
                e.component.cellValue(e.row.rowIndex, "roleCanView", ev.value);
                e.setValue(ev.value);
            } else {
                this.checkRolesChanges(e.row.data, e.dataField, ev.value);
                e.setValue(ev.value);
            }
        },

        checkRoleAllowAllChanges(data, value) {
            const duplicateItems = this.treeList.getDataSource().store()._array.filter(v => v.itemId === data.itemId && v.itemKey !== data.itemKey);
            if (duplicateItems.length != 0) {
                let changes = this.treeList.option("editing.changes");
                duplicateItems.forEach((duplicate) => {
                    var node = this.treeList.getNodeByKey(duplicate.itemKey);
                    if (node) {
                        let curNode = changes.find((el) => {
                            return node.key === el.key;
                        });

                        if (curNode) {
                            curNode.data['roleAllowAll'] = value;
                            curNode.data['roleCanAdd'] = value;
                            curNode.data['roleCanEdit'] = value;
                            curNode.data['roleCanDelete'] = value;
                            curNode.data['roleCanView'] = value;
                        } else {
                            node.data['roleAllowAll'] = value;
                            node.data['roleCanAdd'] = value;
                            node.data['roleCanEdit'] = value;
                            node.data['roleCanDelete'] = value;
                            node.data['roleCanView'] = value;

                            changes.push({
                                key: node.key,
                                data: {...node.data},
                                type: "update",
                            });
                        }
                    }
                });
                this.treeList.option("editing.changes", changes);
            }
        },

        checkRolesChanges(data, dataField, value) {
            const storeArray = this.treeList.getDataSource().store()._array;
            let changes = this.treeList.option("editing.changes") || [];

            const currentNode = this.treeList.getNodeByKey(data.itemKey);
            if (currentNode && currentNode.data) {
                let curChange = changes.find(c => c.key === currentNode.key);
                if (curChange) {
                    curChange.data[dataField] = value;
                } else {
                    currentNode.data[dataField] = value;
                    changes.push({
                        key: currentNode.key,
                        data: currentNode.data,
                        type: "update",
                    });
                }
            }

            const duplicateItems = storeArray.filter(v => v.itemId === data.itemId && v.itemKey !== data.itemKey);

            duplicateItems.forEach((duplicate) => {
                const node = this.treeList.getNodeByKey(duplicate.itemKey);
                if (node && node.data) {
                    let curNode = changes.find(el => node.key === el.key);

                    if (curNode) {
                        curNode.data[dataField] = value;
                    } else {
                        node.data[dataField] = value;
                        changes.push({
                            key: node.key,
                            data: node.data,
                            type: "update",
                        });
                    }

                    this.updateParentState(node, dataField, changes);
                }
            });

            if (currentNode) {
                const children = this.getChildNodes(currentNode);
                children.forEach(child => {
                    if (!child.data) return;

                    let existing = changes.find(c => c.key === child.key);

                    if (existing) {
                        existing.data[dataField] = value;
                    } else {
                        child.data[dataField] = value;
                        changes.push({
                            key: child.key,
                            data: child.data,
                            type: "update",
                        });
                    }
                });

                this.updateParentState(currentNode, dataField, changes);
            }

            this.treeList.option("editing.changes", changes);
            this.treeList.refresh();
        },

        getChildNodes(node) {
            const children = [];

            const walk = (n) => {
                if (!n || !n.children) return;

                n.children.forEach(child => {
                    children.push(child);
                    walk(child);
                });
            };

            walk(node);
            return children;
        },

        getChildrenState(node, dataField, changes) {
            if (!node.children || node.children.length === 0)
                return null;

            const values = node.children.map(child => {
                const change = changes.find(c => c.key === child.key);
                if (change && change.data && dataField in change.data) {
                    return change.data[dataField] === true;
                }
                return child.data?.[dataField] === true;
            });

            const atLeastOneTrue = values.some(v => v === true);

            return atLeastOneTrue;
        },

        updateParentState(node, dataField, changes) {
            if (!node || !node.parent) return;

            const parent = node.parent;

            if (!parent.data) return;

            const state = this.getChildrenState(parent, dataField, changes);

            if (state === null) return;

            let existing = changes.find(c => c.key === parent.key);

            if (existing) {
                existing.data[dataField] = state;
            } else {
                parent.data[dataField] = state;
                changes.push({
                    key: parent.key,
                    data: parent.data,
                    type: "update",
                });
            }

            this.updateParentState(parent, dataField, changes);
        },

        cellPrepared (e) {
            if(e.rowType === "data") {
                if (e.column.dataField == 'roleCanEdit' && e.data.hasEdit === false) {
                    e.cellElement.querySelector(".dx-treelist-checkbox-size").style.display = 'none';
                } 
                else if(e.column.dataField == 'roleCanAdd' && e.data.hasAdd === false) {
                    e.cellElement.querySelector(".dx-treelist-checkbox-size").style.display = 'none';
                }
                else if(e.column.dataField == 'roleCanDelete' && e.data.hasDelete === false) {
                    e.cellElement.querySelector(".dx-treelist-checkbox-size").style.display = 'none';
                }
                else if (e.column.dataField === "roleAllowAll"){
                    if (e.data.hasDelete === false || e.data.hasAdd === false || e.data.hasEdit === false)
                        e.cellElement.querySelector(".dx-treelist-checkbox-size").style.display = 'none';
                }
            }
        },  

        setCellValue(rowData, value) {
            rowData.roleAllowAll = value;
            rowData.roleCanView = value;
        },


        onValueChangedCheck(e, d) {
            let changes = this.treeList.option("editing.changes");
            let dataField =  d.column.dataField

            this.treeList.forEachNode((node) => {
                var nodeData = node.data;
                let dataNodeHasAdd =  nodeData.hasAdd;
                let dataNodeHasEdit =  nodeData.hasEdit;
                let dataNodeHasDelete =  nodeData.hasDelete;
                let curNode = changes.find((el) => {
                    return node.key === el.key;
                });
        
                if (curNode) {
                    if (dataField === 'roleCanAdd' && curNode.data.hasAdd === true){
                        curNode.data[dataField] = e.value;
                    } else if (dataField === 'roleCanEdit' && curNode.data.hasEdit === true){
                        curNode.data[dataField] = e.value;
                    } else if (dataField === 'roleCanDelete'&& curNode.data.hasDelete === true){
                        curNode.data[dataField] = e.value;
                    } else if(dataField === 'roleAllowAll'){
                        curNode.data[dataField] = e.value;
                        curNode.data.roleCanAdd = (e.value ? curNode.data.hasAdd === true: false);
                        curNode.data.roleCanEdit = (e.value ? curNode.data.hasEdit === true: false);
                        curNode.data.roleCanDelete = (e.value ? curNode.data.hasDelete === true: false);
                        curNode.data.roleCanView = e.value;
                    
                    } else if( dataField === 'roleCanView'){
                        curNode.data[dataField] = e.value;
                    }
                } else if((dataField === 'roleCanAdd' && node.data.hasAdd === true) ||
                    (dataField === 'roleCanEdit' && node.data.hasEdit === true) ||
                    (dataField === 'roleCanDelete' && node.data.hasDelete === true) ||
                    ( dataField === 'roleCanView')
                ){
                    changes.push({
                        key: node.key,
                        data: { 
                        [dataField] : e.value ,
                        hasAdd : dataNodeHasAdd,
                        hasEdit : dataNodeHasEdit,
                        hasDelete : dataNodeHasDelete,
                        },
                        type: "update",
                    });
                } else if(
                    dataField === 'roleAllowAll'
                ){
                    changes.push({
                        key: node.key,
                        data: { 
                            [dataField] : e.value ,
                            hasAdd : dataNodeHasAdd,
                            hasEdit : dataNodeHasEdit,
                            hasDelete : dataNodeHasDelete,
                            roleCanAdd : (e.value ? node.data.hasAdd === true: false),
                            roleCanEdit : (e.value ? node.data.hasEdit === true: false),
                            roleCanDelete : (e.value ? node.data.hasDelete === true: false),
                            roleCanView : e.value,
                        },
                        type: "update",
                    });
                } 
            });
            this.treeList.option("editing.changes", changes);
        },

        validate_required() {
            this.isRoleIdValid = this.Rol.description ? true : false;
            return this.isRoleIdValid;
        },

        validate_menu_required() {
            if (this.validate_required()) {
                const userRoleMenuItems = this.treeList.getDataSource().store()._array;
                for (let index = 0; index < userRoleMenuItems.length; index++) {
                    const menu = userRoleMenuItems[index];

                    //If the menu is hidden
                    if (!menu.roleCanView) {
                        //Cannot have add/edit/modify operations
                        if ((menu.hasAdd && menu.roleCanAdd) || (menu.hasDelete && menu.roleCanDelete) || (menu.hasEdit && menu.roleCanEdit)) {
                            let action = [];
                            if (menu.hasAdd && menu.roleCanAdd)
                                action.push(this.$t('Shared.Add'));
                            if (menu.hasEdit && menu.roleCanEdit)
                                action.push(this.$t('Shared.Edit'));
                            if (menu.hasDelete && menu.roleCanEdit)
                                action.push(this.$t('Shared.Delete'));

                            this.showMessage(this.$tc('Msg.Error'), this.$t('userRoleDetails.MenuRequired', {'menu': menu.itemName, 'action': action.join(',')}), "errorAutoHide");
                            return false;
                        }

                        //All his children must be hidden
                        const childItems = userRoleMenuItems.filter(x => x.parentId != null && x.parentId == menu.itemKey);
                        if (childItems.length != 0 && childItems.some(x => x.roleCanView)) {
                            this.showMessage(this.$tc('Msg.Error'), this.$t('userRoleDetails.MenuChildInvalid', {'menu': menu.itemName}), "errorAutoHide");
                            return false;
                        }
                    } else {
                        //All parents should be visible.
                        const parentId = menu.parentId;
                        if (parentId) {
                            const parents = parentId.split('-');
                            const parentItems = userRoleMenuItems.filter(x => parents.indexOf(x.itemId) != -1);
                            if (!parentItems.every(x => x.roleCanView)) {
                                this.showMessage(this.$tc('Msg.Error'), this.$t('userRoleDetails.MenuParentRequired', {'menu': menu.itemName}), "errorAutoHide");
                                return false;
                            }
                        }

                        //At least one child must be visible
                        const childItems = userRoleMenuItems.filter(x => x.parentId != null && x.parentId == menu.itemKey);
                        if (childItems.length != 0 && !childItems.some(x => x.roleCanView)) {
                            this.showMessage(this.$tc('Msg.Error'), this.$t('userRoleDetails.MenuChildHiddenInvalid', {'menu': menu.itemName}), "errorAutoHide");
                            return false;
                        }
                    }
                }
            }

            return this.isRoleIdValid;
        },

        beforeWindowUnload(e) {
            if (this.pendingChanges) {
                e.preventDefault()
                e.returnValue = ''	
            }
        },
    },

    mounted(){
        this.OptionsRightMenu.ItemsList = [];
        let layoutStatus = this.$store.state.layoutStatus;
        switch(layoutStatus) {
            case 'L0R1':
                this.OptionsRightMenu.favButtonAtion = false;
                this.$emit('getVisibleMenu', this.OptionsRightMenu);
            break;
            case 'L1R0':
            case 'L1R1':
                this.OptionsRightMenu.btnvisible = false;
                this.$emit('getVisibleMenu', this.OptionsRightMenu);
            break;
            default:
                this.OptionsRightMenu.favButtonAtion = false;
                this.$emit('getVisibleMenu', this.OptionsRightMenu);
        }

        if (this.$route.params.id) {
            this.RolId = this.$route.params.id;
        }
        
        this.getProviders();
    },

    created(){
        EventBus.$on("onChanged", function (e) {       
            this.pendingChanges = e.Changed
        }.bind(this));
        window.addEventListener('beforeunload', this.beforeWindowUnload)
    },

    beforeDestroy () {
        window.removeEventListener('beforeunload', this.beforeWindowUnload)
    },

    computed: {
        treeList: function() {
            return this.$refs[treeListRefKey].instance;
        },
        treeListPro: function() {
            return this.$refs[treeListProRefKey].instance;
        },
        isDisabled: function(){
            return this.disabled;
        }
    }
};
</script>

<style>

#tasks {
    max-height: 540px;
}

#tasks .dx-treelist-rowsview td {
    vertical-align: middle;
}

.dx-data-row .cell-provider-align {
    vertical-align: middle !important;
    padding-left: 10px !important;
}

.dx-data-row .headercell-view-padding {
    padding: 5px 5px 7px 5px !important;
}

.column-view-check .dx-treelist-rowsview .dx-treelist-empty-space {
    width: 0px !important;
}

.showNote{
	display: auto !important;
}


</style>


